import React, { useState } from 'react'
import {Helmet} from "react-helmet"
import DOMPurify from 'isomorphic-dompurify'
import { DateTime, Interval } from "luxon";

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { setNowPlaying, zedPlayerPlay } from '~/player/actions'
import unescape from 'lodash/unescape'

import subjects from '~/comm'
import { hmsToSecondsOnly } from '~/helpers'

//import style from "~/stylesheets/components/_episode.scss"

const Episode = (props) => {

  const {episode, program, onairnow, routes, index} = props

  const [ strip, setStrip ] = useState({strip: true});

  const next = () => {
    subjects.episode.next('next')
  }

  const prev = () => {
    subjects.episode.next('prev')
  }

  const click = () => {
    setStrip(prevState => (
      prevState.strip === true ? { strip: false } : { strip: true }
    ))
  }

  const playOnDemand = (time) => {
    const { onairnow, episode, program, dispatch } = props

    if (onairnow === "true" || Interval.fromDateTimes(DateTime.fromSQL(episode.start), DateTime.fromSQL(episode.end)).contains(DateTime.local().setZone("Australia/Brisbane")) ) {
      let ondemandSrc
      if (program.defaultFirstAiredGuide === 'fm' || program.guideId === 'fm'){
        // ondemandSrc = 'https://ssl.rockhost.com/proxy/zzzpatr2/stream'
        
        ondemandSrc = 'https://iheart.4zzz.org.au/4zzz'
      }
      else {
        ondemandSrc = 'https://iheart.4zzz.org.au/zed-digital'
      }
      dispatch(zedPlayerPlay({type: 'audio/mp3', src: ondemandSrc}))

      // var zedPlayer = videojs('zed-live')
      // if(!zedPlayer.paused()){
      //   zedPlayer.pause()
      // }
      // zedPlayer.src({type: 'audio/mp3', src: ondemandSrc})
      // zedPlayer.play()
      return
    }

    var show = episode.start
    console.log(show)
    var showt = show.split(' ')
    var ondemandEp = showt[0] + '-' + showt[1].split(':')[0]

    let ondemandSrc = null
    if (program.defaultFirstAiredGuide === 'fm' || program.guideId === 'fm'){
      ondemandSrc = '//undead.4zzz.fm/4zzz/'+ ondemandEp + '-00.mp3'
    }
    else {
      ondemandSrc = '//undead.4zzz.fm/zed-digital/ZD-' + ondemandEp + '-00.mp3'
    }

    dispatch(setNowPlaying(program.name, program.profileImageSmall))

    if (time) {
      var realtime;
      
      if (DateTime.fromSQL(episode.start).hour >= 12 ) {
        realtime =  DateTime.fromFormat(time + ' PM', 'tt').toLocaleString(DateTime.TIME_24_WITH_SECONDS) 
      }
      else {
        realtime =  DateTime.fromFormat(time + ' AM', 'tt').toLocaleString(DateTime.TIME_24_WITH_SECONDS) 
      }


      // aproxtime = aprox.split(' ')[1];
       var contexttime = episode.start.split(' ')[1];


       var seconds = Math.abs(hmsToSecondsOnly(realtime) - hmsToSecondsOnly(contexttime));
      //  zedPlayer.currentTime(seconds);
       console.log(seconds);
       dispatch(zedPlayerPlay({type: 'audio/mp3', src: ondemandSrc}, seconds))

    }
    else {
      dispatch(zedPlayerPlay({type: 'audio/mp3', src: ondemandSrc}))
    }
  }
  

  let hasNext = false, hasPrev = false
  if (index && index.position + 1 < index.total) {
    hasNext = true
  }
  if (index && index.position !== 0) {
    hasPrev = true
  }

  let stripTags = function(str, slice){
    str = unescape(str)
    if (typeof window !== 'undefined') {
      str = DOMPurify.sanitize(str, {ALLOWED_TAGS: []})
      if(slice && slice.strip){str = str.slice(0, 140) }
    }
    //str = DOMPurify.sanitize(str, {ALLOWED_TAGS: ['b', 'i', 'strong', 'em', 'a', 'p'], ALLOWED_ATTR: ['href'] });
    return str
  }

  let stripTagsAllow = function(str, slice){
    str = unescape(str)
    if (typeof window !== 'undefined') {
      str =  DOMPurify.sanitize(str, {ALLOWED_TAGS: ['b', 'i', 'strong', 'em', 'a', 'p', 'br'], ALLOWED_ATTR: ['href'] })
      if(slice){str = str.slice(0, 140) }
    }
    //str = DOMPurify.sanitize(str, {ALLOWED_TAGS: ['b', 'i', 'strong', 'em', 'a', 'p'], ALLOWED_ATTR: ['href'] });
    return str
  }

  // let startold = episode && episode.start ? moment(episode.start) : program.start ? moment(program.start, 'HH:mm:ss') : program.schedule[0] ?  moment(program.schedule[0].start, 'HH:mm:ss') : moment()
  // const DT = DateTime;
  let start = episode && episode.start ? DateTime.fromSQL(episode.start) : program.start ? DateTime.fromFormat(program.start, 'TT') : program.schedule[0] ?  DateTime.fromFormat(program.schedule[0].start, 'TT') : DateTime
  let end = program.duration ? start.plus({seconds: program.duration}) : episode.duration ? start.plus({seconds: episode.duration}) :  program.schedule[0] ? start.plus({ seconds: program.schedule[0].duration }) : DateTime
  const [ head ] = routes.matches
  return(
    <div style={{pointerEvents: 'all'}} className="program-details">
      <div>
        { head.match.path !== '/' &&
          <Helmet>
            <title>{unescape(program.name) + ' - ' + start.toLocaleString(DateTime.DATE_FULL)}</title>
            <meta name="description" content={ episode && episode.description ?  episode.description.replace(/<[^>]+>/g, '') + '\r\n\rn' : program.description ? program.description.replace(/<[^>]+>/g, '') : unescape(program.name) } />
            <meta name="og:description" content={  episode && episode.description ?  episode.description.replace(/<[^>]+>/g, '') + '\r\n\rn' : program.description ? program.description.replace(/<[^>]+>/g, '') : unescape(program.name) } />
            <meta property="og:title" content={unescape(program.name) + ' - ' + start.toLocaleString(DateTime.DATE_FULL)} />
            <meta property="og:image" content={episode && episode.imageUrl ? episode.imageUrl : program.bannerImageUrl} />
            <meta property="og:type" content="website" />
          </Helmet>
        }


        {(episode || onairnow === 'true') && <div className="play-button" onClick={playOnDemand}><i className="fa fa-play" aria-hidden="true"></i></div>
        }
        <Link to={'/program/' + program.slug}><h1><span>{unescape(program.name)}</span></h1></Link>
        {program.broadcasters && <h2><span>{unescape(program.broadcasters)}</span></h2> }
        <h3 className="day"><span>{start.toFormat('cccc')}</span></h3>
        <h3 className="time"><span>{start.toFormat('t')} - {end.toFormat('t')}</span></h3>

        <div dangerouslySetInnerHTML={{__html: stripTags(program.description, strip) }} ></div>
        { program.description && program.description.length > 200 ? strip.strip ? <div onClick={click}>...more</div> : <div onClick={click}>...less</div> : null }
        <h3 className="date">
          <span>{ (episode ? DateTime.fromSQL(episode.start) : DateTime.now() ).toFormat('dd MMMM, y')}</span>
          { program.twitterHandle ?
            <a href={ "https://twitter.com/" + program.twitterHandle} target="_blank" >
              <span className="fa-stack fa-pull-right">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa-inverse fa fa-stack-1x fa-twitter"></i>
              </span>
            </a>
          : null }
          { program.facebookPage ?
            <a href={ "https://facebook.com/" + program.facebookPage} target="_blank" >
              <span className="fa-stack fa-pull-right">
                <i className="fa fa-circle fa-stack-2x" ></i>
                <i className="fa-inverse fa fa-stack-1x fa-facebook"></i>
              </span>
            </a>
          : null }
          { index ?
            <span className="calendar">
              { hasPrev ? <i onClick={prev} className="fa fa-angle-left fa-fw" aria-hidden="true"></i>: <i className="fa fa-angle-left fa-fw inactive" aria-hidden="true"></i> }
              <i className="fa fa-calendar fa-fw" aria-hidden="true"></i>
              { hasNext ? <i onClick={next} className="fa fa-angle-right fa-fw" aria-hidden="true"></i>: <i className="fa fa-angle-right fa-fw inactive" aria-hidden="true"></i> }
            </span>
          : null }
        </h3>
        { episode && episode.title && <h3><span>{unescape(episode.title)}</span></h3> }
        { episode && episode.description && <div className="episode-description" dangerouslySetInnerHTML={{__html: episode.description }} ></div> }
        { episode && episode.notes && <div className="episode-notes" dangerouslySetInnerHTML={{__html: stripTagsAllow(episode.notes) }} ></div> }
      </div>
    </div>
  )
}

export default connect(state => ({routes: state.routes})) (Episode)
